import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { EstoqueProduto } from '../../types/estoque';
import { estoqueProdutosService, catalogoProdutosService, armazensService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<EstoqueProduto>[] = [
  {
    name: 'produto',
    label: 'Produto',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      catalogoProdutosService.list,
      (item: any) => `${item.codigo ?? ''} ${item.descricao ?? ''}`.trim() || String(item.id),
    ),
    required: true,
  },
  { name: 'quantidade_disponivel', label: 'Quantidade disponivel', type: 'number' },
  {
    name: 'armazem',
    label: 'Armazem',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      armazensService.list,
      (item: any) => item.nome ?? `Armazem #${item.id}`,
    ),
  },
  { name: 'localizacao', label: 'Localizacao' },
  { name: 'observacoes', label: 'Observacoes', type: 'textarea' },
];

export const EstoqueProdutosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Estoque de produtos"
    description="Controle de saldo de produtos."
    fields={fields}
    service={estoqueProdutosService}
    redirectPath="/admin/estoque/estoque-produtos"
    cancelPath="/admin/estoque/estoque-produtos"
  />
);
